<template>
  <router-view :key="$route.fullPath" />

  <the-notifier />

  <modal-dialog />
</template>

<script setup>
import { watch } from 'vue';
import { isLoggedInUser } from './composables/useAuth';
import { useRouter } from 'vue-router';
import TheNotifier from './components/TheNotifier.vue';
import ModalDialog from './components/ModalDialog.vue';

const router = useRouter();

watch(isLoggedInUser, value => {
  if (value) {
    router.push('/');
  }
});
</script>
